import { ServiceUpdate } from "@/features/clinician/services/components/service-update";

const EditServices = () => {
    return (
        <>
            <div className="px-4 py-8">
                <div className="container mx-auto">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your services
                    </h1>
                    <ServiceUpdate />
                </div>
            </div>
        </>
    );
};

export default EditServices;
